// packages/data/src/dispatch.ts
import defaultRegistry from "./default-registry";
function dispatch(storeNameOrDescriptor) {
  return defaultRegistry.dispatch(storeNameOrDescriptor);
}
export {
  dispatch
};
//# sourceMappingURL=dispatch.js.map
